module.exports = __webpack_public_path__ + "static/media/Sante_Bienetre_PictoCdlT.6fc4c772.png";